const BoxSvg = ({
  width = 16,
  height = 16,
  stroke = '#C3C4CF',
  fill = 'white',
}: {
  width?: number;
  height?: number;
  stroke?: string;
  fill?: string;
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0)">
        <path
          d="M14.6668 4.66683L8.00016 1.3335L1.3335 4.66683V11.3335L8.00016 14.6668L14.6668 11.3335V4.66683Z"
          stroke={stroke}
          strokeLinejoin="round"
        />
        <path
          d="M1.3335 4.66667L8.00016 8M8.00016 8V14.6667M8.00016 8L14.6668 4.66667M11.3335 3L4.66683 6.33333"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="16" height="16" fill={fill} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BoxSvg;
